import type { QueryClient } from "@tanstack/react-query"
import { QueryClientProvider } from "@tanstack/react-query"
import type * as React from "react"

/**
 * Cross-app provider composition. Deliberately thin at bootstrap: only Query
 * needs a provider today (@effect/atom-react reads a global registry). Grows
 * only when a second provider is proven necessary in a real app.
 */
export function AppProviders({
  queryClient,
  children
}: {
  readonly queryClient: QueryClient
  readonly children: React.ReactNode
}) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
